import { render, staticRenderFns } from "./YbMap.vue?vue&type=template&id=642851c8&scoped=true&"
import script from "./YbMap.vue?vue&type=script&lang=js&"
export * from "./YbMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642851c8",
  null
  
)

export default component.exports